<template>
  <div class="crud_form_wrapper single_show_content_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.showJob") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #26a1d6">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <!-- ==== Start:: Status Badges ==== -->
      <div class="badges_wrapper justify-content-end">
        <v-chip :color="data.is_active ? 'green' : 'red'" text-color="white">
          {{ data.is_active ? $t("STATUS.active") : $t("STATUS.notActive") }}
        </v-chip>
      </div>
      <!-- ==== End:: Status Badges ==== -->

      <!-- ==== Start:: Main Data ==== -->
      <form>
        <div class="row">
          <!-- Start:: Name Arabic Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.jobNameAr')"
            v-model.trim="data.name_ar"
            disabled
          />
          <!-- End:: Name Arabic Input -->

          <!-- Start:: Name English Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.jobNameEn')"
            v-model.trim="data.name_en"
            disabled
          />
          <!-- End:: Name English Input -->

          <!-- Start:: Created At Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.createdAt')"
            v-model.trim="data.created_at"
            disabled
          />
          <!-- End:: Created At Input -->
        </div>
      </form>
      <!-- ==== End:: Main Data ==== -->
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
export default {
  name: "ShowJob",

  props: {
    id: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      // Start:: Data
      data: {
        name_ar: null,
        name_en: null,
        is_active: false,
        created_at: null,
      },
      // End:: Data
    };
  },

  methods: {
    // Start:: Get Data To Show
    async getDataToShow() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `jobs/${this.id}`,
        });

        const job = res.data.data.data;

        this.data.name_ar = job.name_ar || job.name;
        this.data.name_en = job.name_en || job.name;
        this.data.is_active = job.is_active;
        this.data.created_at = job.created_at;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    // End:: Get Data To Show
  },

  async created() {
    await this.getDataToShow();
  },
};
</script>
